import {
  ACTION_USER_INFO_ERROR,
  ACTION_USER_INFO_LOADING,
  ACTION_USER_INFO_LOADED,
  ACTION_UPDATE_USER_INFO_ERROR,
  ACTION_UPDATE_USER_INFO_LOADING,
  ACTION_UPDATE_USER_INFO_LOADED,
  ACTION_ENTERPRISE_ACCOUNT_ADD_USER_ERROR,
  ACTION_ENTERPRISE_ACCOUNT_ADD_USER_LOADED,
  ACTION_ENTERPRISE_ACCOUNT_ADD_USER_LOADING,
} from '../constants'
import builder from './reducerBuilder'

export default builder(
  [ACTION_USER_INFO_LOADING, ACTION_UPDATE_USER_INFO_LOADING, ACTION_ENTERPRISE_ACCOUNT_ADD_USER_LOADING],
  [ACTION_USER_INFO_LOADED, ACTION_UPDATE_USER_INFO_LOADED, ACTION_ENTERPRISE_ACCOUNT_ADD_USER_LOADED],
  [ACTION_USER_INFO_ERROR, ACTION_UPDATE_USER_INFO_ERROR, ACTION_ENTERPRISE_ACCOUNT_ADD_USER_ERROR])



// WEBPACK FOOTER //
// ./src/store/userInfoReducer.js